import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import {
  FiSearch,
  FiFilter,
  FiUser,
  FiUserX,
  FiUserCheck,
  FiEdit,
  FiShield,
  FiDownload,
  FiRefreshCw,
} from "react-icons/fi";
import Swal from "sweetalert2";
import ReactPaginate from "react-paginate";

export default function UserDirectory() {
  const [searchTerm, setSearchTerm] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [roleFilter, setRoleFilter] = useState("all");
  const [currentPage, setCurrentPage] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  // Static data - replace with API calls later
  const [users] = useState([
    {
      id: 1,
      name: "Rajesh Kumar",
      email: "rajesh@example.com",
      phone: "+91 9876543210",
      role: "Client",
      status: "Active",
      kycStatus: "Verified",
      agentMapping: "Agent-001",
      registeredDate: "2024-01-15",
    },
    {
      id: 2,
      name: "Priya Sharma",
      email: "priya@example.com",
      phone: "+91 9876543211",
      role: "Client",
      status: "Active",
      kycStatus: "Pending",
      agentMapping: "Agent-002",
      registeredDate: "2024-01-20",
    },
    {
      id: 3,
      name: "Amit Patel",
      email: "amit@example.com",
      phone: "+91 9876543212",
      role: "Agent",
      status: "Active",
      kycStatus: "Verified",
      agentMapping: "N/A",
      registeredDate: "2023-12-10",
    },
    {
      id: 4,
      name: "Sneha Reddy",
      email: "sneha@example.com",
      phone: "+91 9876543213",
      role: "Client",
      status: "Blocked",
      kycStatus: "Rejected",
      agentMapping: "Agent-001",
      registeredDate: "2024-01-05",
    },
  ]);

  const handleAssignRole = (userId) => {
    Swal.fire({
      title: "Assign Role",
      html: `
        <select id="roleSelect" class="swal2-select">
          <option value="Client">Client</option>
          <option value="Agent">Agent</option>
          <option value="Admin">Admin</option>
        </select>
      `,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: "Assign",
      confirmButtonColor: "#5000C0",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Success!", "Role has been assigned.", "success");
      }
    });
  };

  const handleBlockUnblock = (userId, currentStatus) => {
    Swal.fire({
      title: `${currentStatus === "Active" ? "Block" : "Unblock"} User?`,
      text: `This user will be ${currentStatus === "Active" ? "blocked" : "unblocked"}.`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: currentStatus === "Active" ? "#ef4444" : "#10b981",
      cancelButtonColor: "#3085d6",
      confirmButtonText: `Yes, ${currentStatus === "Active" ? "Block" : "Unblock"}!`,
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Updated!", `User has been ${currentStatus === "Active" ? "blocked" : "unblocked"}.`, "success");
      }
    });
  };

  const handleResetPassword = (userId) => {
    Swal.fire({
      title: "Reset Password?",
      text: "A new password will be sent to the user's email.",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#5000C0",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, Reset!",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire("Success!", "Password reset email has been sent.", "success");
      }
    });
  };

  const filteredUsers = users.filter((user) => {
    const matchesSearch =
      user.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
      user.phone.includes(searchTerm);
    const matchesStatus = statusFilter === "all" || user.status === statusFilter;
    const matchesRole = roleFilter === "all" || user.role === roleFilter;
    return matchesSearch && matchesStatus && matchesRole;
  });

  const indexOfLastItem = (currentPage + 1) * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredUsers.slice(indexOfFirstItem, indexOfLastItem);
  const pageCount = Math.ceil(filteredUsers.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(0);
  };

  return (
    <>
      <div className="main-content">
        <div className="page-wrapper page-settings">
          <div className="content">
            {/* Breadcrumb and Header Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
                  <div className="content-page-header content-page-headersplit">
                <h5>User Directory</h5>
              </div>
              <nav
                aria-label="breadcrumb"
                style={{ "--bs-breadcrumb-divider": "none", marginBottom: "15px" }}
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <NavLink to="/dashboard">Dashboard</NavLink> /
                  </li>
                  <li className="breadcrumb-item">
                    <NavLink to="/admin/users/directory">Users</NavLink>/
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    User Directory
                  </li>
                </ol>
              </nav>
          
            </div>
          

            {/* Filters Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="d-flex justify-content-between align-items-center flex-wrap">
                {/* Filters */}
                <div className="row g-2 flex-grow-1">
                  {/* Search */}
                  <div className="col-12 col-md-4">
                    <div className="position-relative">
                      <FiSearch
                        style={{
                          position: "absolute",
                          left: "12px",
                          top: "50%",
                          transform: "translateY(-50%)",
                          color: "#64748b",
                          zIndex: 1,
                        }}
                      />
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Search by name, email, or phone..."
                        value={searchTerm}
                        onChange={(e) => {
                          setSearchTerm(e.target.value);
                          setCurrentPage(0);
                        }}
                        style={{ paddingLeft: "40px" }}
                      />
                    </div>
                  </div>

                  {/* Status Filter */}
                  <div className="col-12 col-md-3">
                    <select
                      className="form-control"
                      value={statusFilter}
                      onChange={(e) => {
                        setStatusFilter(e.target.value);
                        setCurrentPage(0);
                      }}
                    >
                      <option value="all">All Status</option>
                      <option value="Active">Active</option>
                      <option value="Blocked">Blocked</option>
                    </select>
                  </div>

                  {/* Role Filter */}
                  <div className="col-12 col-md-3">
                    <select
                      className="form-control"
                      value={roleFilter}
                      onChange={(e) => {
                        setRoleFilter(e.target.value);
                        setCurrentPage(0);
                      }}
                    >
                      <option value="all">All Roles</option>
                      <option value="Client">Client</option>
                      <option value="Agent">Agent</option>
                      <option value="Admin">Admin</option>
                    </select>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="ms-md-3 mt-3 mt-md-0">
                  <button className="btn btn-primary me-2">
                    Export
                  </button>
                  <button className="btn btn-secondary">
                    Refresh
                  </button>
                </div>
              </div>
            </div>

            {/* Table Section with Card Shadow */}
            <div
              className="mb-4"
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
                padding: "20px",
              }}
            >
              <div className="row">
                <div className="col-12">
                  <div className="table-responsive">
                    <table className="table datatable">
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Email</th>
                          <th>Phone</th>
                          <th>Role</th>
                          <th>Status</th>
                          <th>KYC Status</th>
                          <th>Agent Mapping</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems.length === 0 ? (
                          <tr>
                            <td colSpan="8">No data available</td>
                          </tr>
                        ) : (
                          currentItems.map((user) => (
                            <tr key={user.id}>
                              <td style={{ fontWeight: "500" }}>{user.name}</td>
                              <td>{user.email}</td>
                              <td>{user.phone}</td>
                              <td>
                                <span className="badge" style={{
                                  background: "#f0f9ff",
                                  color: "#006e82",
                                  padding: "6px 12px",
                                  borderRadius: "6px",
                                  fontSize: "12px",
                                  fontWeight: "600",
                                }}>
                                  {user.role}
                                </span>
                              </td>
                              <td>
                                <span className={user.status === "Active" ? "badge-active" : "badge-pending"}>
                                  {user.status}
                                </span>
                              </td>
                              <td>
                                <span className={user.kycStatus === "Verified" ? "badge-active" : user.kycStatus === "Pending" ? "badge-pending" : "badge-pending"}>
                                  {user.kycStatus}
                                </span>
                              </td>
                              <td>{user.agentMapping}</td>
                              <td>
                                <div className="table-actions d-flex justify-content-center">
                                  <div
                                    className="delete-table me-2"
                                    onClick={() => handleAssignRole(user.id)}
                                    style={{ cursor: "pointer" }}
                                    title="Assign Role"
                                  >
                                    <i className="fas fa-shield"></i>
                                  </div>
                                  <div
                                    className="delete-table me-2"
                                    onClick={() => handleBlockUnblock(user.id, user.status)}
                                    style={{ cursor: "pointer" }}
                                    title={user.status === "Active" ? "Block User" : "Unblock User"}
                                  >
                                    {user.status === "Active" ? (
                                      <i className="fas fa-user-times"></i>
                                    ) : (
                                      <i className="fas fa-user-check"></i>
                                    )}
                                  </div>
                                  <div
                                    className="delete-table"
                                    onClick={() => handleResetPassword(user.id)}
                                    style={{ cursor: "pointer" }}
                                    title="Reset Password"
                                  >
                                    <i className="fas fa-redo"></i>
                                  </div>
                                </div>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Pagination */}
              {pageCount > 1 && (
                <nav className="mt-4 pagination justify-content-end gap-2">
                  <select
                    className="form-select"
                    style={{ width: "70px", padding: "0 13px" }}
                    value={itemsPerPage}
                    onChange={handleItemsPerPageChange}
                  >
                    <option value="10">10</option>
                    <option value="20">20</option>
                    <option value="30">30</option>
                    <option value="50">50</option>
                    <option value="100">100</option>
                  </select>
                  <ReactPaginate
                    className="pagination justify-content-center"
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    pageCount={pageCount}
                    pageClassName={"page-link"}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    previousLinkClassName={"page-link"}
                    nextLinkClassName={"page-link"}
                    disabledClassName={"disabled"}
                    activeClassName={"active"}
                  />
                </nav>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
